import React from "react";
import { ChevronRight } from "lucide-react";
import { getIcon } from "@/data/catalogHelpers";
import ScrollableArea from "./ScrollableArea";

export default function SummaryPage({ studio, modalities, onSelect }) {
  const s = studio || {};
  return (
    <div
      className="relative w-full h-full paper-bg flex flex-col p-6 sm:p-8"
      data-testid="summary-page"
    >
      <div className="text-center shrink-0">
        <p className="font-body text-[0.58rem] uppercase tracking-[0.4em] text-[var(--gold)]">
          {s.studioName || "Studio da Beleza"}
        </p>
        <h2 className="font-heading text-4xl sm:text-5xl text-[var(--offwhite)] mt-1 leading-none">
          Nossos procedimentos
        </h2>
        <div className="gold-hairline w-24 mx-auto mt-4" />
      </div>

      <ScrollableArea
        className="flex-1 min-h-0 mt-5"
        contentClassName="pr-1"
        testid="summary-scroll"
      >
        <ul className="grid grid-cols-1 gap-1.5 pb-8">
          {(modalities || []).map((m, idx) => {
            const Icon = getIcon(m.icon);
            return (
              <li key={m.id || m.slug || idx}>
                <button
                  data-testid={`summary-item-${idx}`}
                  onClick={() => onSelect(idx)}
                  className="group w-full flex items-center gap-3 px-3 py-2.5 border border-[rgba(212,175,55,0.14)] hover:border-[rgba(212,175,55,0.5)] hover:bg-[rgba(212,175,55,0.05)] transition-colors duration-300 text-left"
                >
                  <span className="shrink-0 w-8 h-8 flex items-center justify-center border border-[rgba(212,175,55,0.3)] rounded-full">
                    <Icon size={15} className="text-[var(--gold)]" strokeWidth={1.4} />
                  </span>
                  <span className="flex-1 font-body text-[0.8rem] tracking-wide text-[var(--offwhite)] group-hover:text-[var(--champagne)] transition-colors">
                    {m.title}
                  </span>
                  <ChevronRight
                    size={16}
                    className="text-[var(--muted)] group-hover:text-[var(--gold)] group-hover:translate-x-1 transition-all duration-300"
                    strokeWidth={1.4}
                  />
                </button>
              </li>
            );
          })}
        </ul>
      </ScrollableArea>

      <p className="shrink-0 text-center font-script text-lg text-[var(--nude)] mt-4">
        Seu autocuidado é o seu melhor investimento
      </p>
    </div>
  );
}
